import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Linkedin, Instagram } from 'lucide-react';

export default function Footer({ onImpressum, onDatenschutz, onAGB }) {
  const { t, lang } = useLanguage();

  return (
    <footer data-testid="footer" className="bg-[#0a0a0a] border-t border-[#1a1a1a] py-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <img src="/assets/logo.webp" alt="ENBET Consulting Logo" width="200" height="120" loading="lazy" decoding="async" className="h-8 w-auto" />
          <span
            className="text-white/30 text-xs"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            &copy; {new Date().getFullYear()} ENBET Consulting. {t('footer.rights')}
          </span>
        </div>

        <div className="flex items-center gap-6">
          <a
            data-testid="footer-linkedin-company"
            href="https://www.linkedin.com/company/enbet-consulting/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={lang === 'de' ? 'ENBET auf LinkedIn' : 'ENBET on LinkedIn'}
            className="text-white/30 hover:text-[#befa0a] transition-colors flex items-center gap-1.5"
            title={lang === 'de' ? 'ENBET Consulting auf LinkedIn' : 'ENBET Consulting on LinkedIn'}
          >
            <Linkedin size={16} />
            <span className="text-xs uppercase tracking-[0.1em] hidden sm:inline" style={{ fontFamily: "'Oswald', sans-serif" }}>
              ENBET
            </span>
          </a>
          <a
            data-testid="footer-linkedin-personal"
            href="https://www.linkedin.com/in/sebastian-funke-enbet-consulting/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={lang === 'de' ? 'Sebastian Funke auf LinkedIn' : 'Sebastian Funke on LinkedIn'}
            className="text-white/30 hover:text-[#befa0a] transition-colors flex items-center gap-1.5"
            title={lang === 'de' ? 'Sebastian Funke auf LinkedIn' : 'Sebastian Funke on LinkedIn'}
          >
            <Linkedin size={16} />
            <span className="text-xs uppercase tracking-[0.1em] hidden sm:inline" style={{ fontFamily: "'Oswald', sans-serif" }}>
              Sebastian
            </span>
          </a>
          <a
            data-testid="footer-instagram"
            href="https://www.instagram.com/enbet_consulting/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={lang === 'de' ? 'ENBET auf Instagram' : 'ENBET on Instagram'}
            className="text-white/30 hover:text-[#befa0a] transition-colors flex items-center gap-1.5"
            title={lang === 'de' ? 'ENBET Consulting auf Instagram' : 'ENBET Consulting on Instagram'}
          >
            <Instagram size={16} />
            <span className="text-xs uppercase tracking-[0.1em] hidden sm:inline" style={{ fontFamily: "'Oswald', sans-serif" }}>
              Instagram
            </span>
          </a>
          <span className="text-white/10 hidden md:inline">·</span>
          <Link
            data-testid="footer-ki-team"
            to="/ki-team"
            className="text-white/30 text-xs uppercase tracking-[0.1em] hover:text-[#befa0a] transition-colors"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            {lang === 'de' ? 'KI-Team' : 'AI Team'}
          </Link>
          <Link
            data-testid="footer-meine-daten"
            to="/meine-daten"
            className="text-white/30 text-xs uppercase tracking-[0.1em] hover:text-[#befa0a] transition-colors"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            {lang === 'de' ? 'Meine Daten' : 'My Data'}
          </Link>
          <button
            data-testid="footer-privacy"
            onClick={onDatenschutz}
            className="text-white/30 text-xs uppercase tracking-[0.1em] hover:text-[#befa0a] transition-colors"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            {t('footer.privacy')}
          </button>
          <button
            onClick={onAGB}
            className="text-white/30 text-xs uppercase tracking-[0.1em] hover:text-[#befa0a] transition-colors"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            {lang === 'de' ? 'AGB' : 'Terms'}
          </button>
          <button
            data-testid="footer-imprint"
            onClick={onImpressum}
            className="text-white/30 text-xs uppercase tracking-[0.1em] hover:text-[#befa0a] transition-colors"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            {t('footer.imprint')}
          </button>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-6 pt-4 border-t border-[#1a1a1a]">
        <p data-testid="footer-accessibility" className="text-white/20 text-[11px] text-center" style={{ fontFamily: "'Manrope', sans-serif" }}>
          Wir arbeiten kontinuierlich an der Barrierefreiheit dieser Website.
        </p>
      </div>
    </footer>
  );
}
